export default "__VITE_ASSET__D5jD13jL__"